<template>
	<div class="comments">
		<div v-for="(comment, i) in comments.results" :key="i" class="container">
			<div class="row">
				<div class="col-sm-12 col-lg-4">
					<h3 class="comments__headline">{{comment.first_name}}</h3>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-1">
					<span class="comments__breed">{{getBreedName(comment.breed)}}</span>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-2">
					<div class="comments__stars">
						<img v-for="star in 6" v-if="star <= comment.score" src="/static/img/star-gold.svg" alt="">
						<img v-for="star in 6" v-if="star > comment.score" src="/static/img/star-empty.svg" alt="">
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-8">
					<p class="comments__comment">
						{{comment.comment}}
					</p>
				</div>
			</div>
			<div v-if="comment.is_author" class="row">
				<div class="col-sm-12 col-lg-11">
					<button
						class="comments__button comments__button--remove"
						@click="removeComment(comment.id)"
						v-text="$t('judges.removeComment')"
					/>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-11">
					<div class="comments__divider"></div>
				</div>
			</div>
		</div>

		<PaginationComponent :count="comments.count"
							 :currentPage="comments.currentPage"
							 @pageChanged="changePage">
		</PaginationComponent>
	</div>
</template>

<script>
	import PaginationComponent from '../../PaginationComponent'
	import axios from 'axios'

	export default {
		props: [
			'comments'
		],
		components: {
			PaginationComponent
		},
		data () {
			return {
				currentPage: 1,
				breeds: []
			}
		},
		methods: {
			changePage (newPage) {
				this.currentPage = newPage
				this.$emit('changePage', newPage)
			},
			fetchBreeds () {
				return axios.get('/api/dogs/subgroup/autocomplete/', {
				})
					.then(response => {
						this.breeds = response.data
					})
					.catch(error => {
						console.error(error)
					})
			},
			getBreedName (id) {
				if (id) {
					const breed = this.breeds.filter(breed => breed.id === id)
					return breed[0].name
				} else {
					return ''
				}
			},
			removeComment (id) {
				axios.delete(`/api/judges/comments/${ id }`)
					.then(() => { this.$emit('commentRemoved') })
					.catch(error => { console.error(error) })
			}
		},
		created () {
			this.fetchBreeds()
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";

	.comments {
		padding-top: 15px;
		&__headline {
			font-family: $lato-bold;
			font-size: 26px;
			text-align: left;
			margin: 0;
			margin-bottom: 10px;
		}
		&__breed {
			display: block;
			font-family: $lato-bold;
			font-size: 14px;
			text-transform: uppercase;
			color: $gray-filter;
			text-align: left;
			margin-bottom: 15px;
		}
		&__stars {
			display: flex;
			align-items: center;
			margin-bottom: 20px;
			img {
				margin-right: 5px;
			}
		}
		&__comment {
			font-size: 16px;
			text-align: left;
			line-height: 22px;
			margin: 0;
			margin-bottom: 35px;
		}
		&__button {
			display: flex;
			justify-content: center;
			align-items: center;

			background-color: $black;
			margin: 0 0 10px auto;
			padding: 15px;
			height: 40px;

			font-family: $lato-bold;
			font-size: 16px;
			color: #fff;
			text-transform: uppercase;

			border: none;
			text-decoration: none;
			cursor: pointer;
		}
		&__divider {
			width: 100%;
			height: 4px;
			background-color: $black;
			margin-bottom: 20px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Judge/Details/CommentsComponent.vue